import React from "react";
import OutputCard from "./OutputCard";
import StandaloneSensorCard from "./StandaloneSensorCard";

export default function IrrigationZone({ controls, actions }) {
  const rf = controls.standalones.rotorFlow;

  return (
    <div className="zone-container irrigation-zone">
      <h3 className="zone-title">Irrigation — Floor / Root Level</h3>
      {controls.outputs.map((out) => (
        <OutputCard key={out.id} output={out} />
      ))}
      <StandaloneSensorCard
        label="Rotor Flow Sensor"
        present={rf.present}
        onToggle={(v) => actions.updateStandalone("rotorFlow.present", v)}
      />
    </div>
  );
}
